import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
      display: "flex",
      flexDirection: "row",
      userSelect: "none",
    },
    contact: {
      marginLeft: spacing.s,
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
    },
    secondary: {
      color: theme.text.secondary,
    },
    right: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
    },
    cta: {
      cursor: "pointer",
      display: "flex",
      marginLeft: spacing.m,
    },
    remove: {
      fontWeight: 600,
      color: theme.shared.cta.cancel,
    },
    cancel: {
      fontWeight: 600,
      color: theme.shared.cta.cancel,
    },
    resend: {
      fontWeight: 600,
      color: theme.shared.cta.resend,
    },
    resent: {
      fontWeight: 600,
      marginLeft: spacing.m,
      color: theme.shared.cta.sent,
    },
    loader: {
      marginLeft: spacing.m,
    },
  };

  return styles;
};
